module.exports = __webpack_public_path__ + "static/img/research.db323d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/research.png
// module id = 1KOQ
// module chunks = 12